import { SVGProps } from 'react'

const DiscordColorIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M13.5535 2.95234C12.5023 2.47107 11.3925 2.12964 10.2526 1.93677C10.0966 2.21563 9.95547 2.50253 9.82976 2.79629C8.6155 2.61332 7.38067 2.61332 6.16641 2.79629C6.04063 2.50257 5.89949 2.21566 5.74357 1.93677C4.60289 2.13126 3.4924 2.47351 2.44013 2.95486C0.351096 6.04562 -0.215207 9.05962 0.0679444 12.0308C1.29133 12.9347 2.66066 13.6222 4.11639 14.0632C4.44417 13.6224 4.73422 13.1547 4.98346 12.6651C4.51007 12.4883 4.05317 12.2702 3.61804 12.0132C3.73256 11.9302 3.84456 11.8446 3.95279 11.7615C5.21891 12.357 6.60083 12.6657 7.99997 12.6657C9.39912 12.6657 10.781 12.357 12.0472 11.7615C12.1566 11.8509 12.2686 11.9365 12.3819 12.0132C11.9459 12.2706 11.4882 12.4891 11.014 12.6664C11.2629 13.1557 11.553 13.623 11.881 14.0632C13.338 13.6239 14.7084 12.9368 15.932 12.0321C16.2642 8.58645 15.3644 5.60013 13.5535 2.95234ZM5.34212 10.2036C4.55307 10.2036 3.90119 9.4875 3.90119 8.60658C3.90119 7.72566 4.53042 7.00331 5.3396 7.00331C6.14879 7.00331 6.79563 7.72566 6.78179 8.60658C6.76795 9.4875 6.14627 10.2036 5.34212 10.2036ZM10.6578 10.2036C9.86752 10.2036 9.21815 9.4875 9.21815 8.60658C9.21815 7.72566 9.84738 7.00331 10.6578 7.00331C11.4683 7.00331 12.1101 7.72566 12.0962 8.60658C12.0824 9.4875 11.462 10.2036 10.6578 10.2036Z"
      fill="#5865F2"
    />
  </svg>
)
export default DiscordColorIcon
